import apiClient from "./interceptor"

export const getReports = async (secureCode) => {
    try {
        const response = await apiClient.post(
            '/v1/analytics/therapy/getCombinedPerfomanceData',
            secureCode ? { secureCode } : {}
        );
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}

export const getAnalyticsData = async () => {
    try {
        const response = await apiClient.post(
            'v1/analytics/therapy/users-improved-analytics',
        );
        return response;
    } catch (err) {
        console.log(err);
        return err;
    }
}
